import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface UseGuardianConfirmModalProps {
    onConfirm: () => void;
}

export const useGuardianConfirmModal = ({ onConfirm }: UseGuardianConfirmModalProps) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = useCallback(() => {
        setIsModalOpen(true);
    }, []);

    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false);
    }, []);

    const handleConfirm = useCallback(() => {
        onConfirm();
        handleCloseModal();
    }, [onConfirm, handleCloseModal]);

    const handleToggleDialog = useCallback(() => {
        setIsModalOpen((prev) => !prev);
    }, []);

    return {
        isModalOpen,
        handleOpenModal,
        handleCloseModal,
        handleConfirm,
        handleToggleDialog,
        modalContent: {
            title: t('epic.esport.guardian.warning1'),
            description: t('epic.esport.guardian.warning2')
        }
    };
};
